
(function(){
  const used = new Set();
  document.querySelectorAll('section.room-break').forEach(br => {
    const head = br.querySelector('.rb-head'); const next = br.nextElementSibling;
    if (!head || !next || !next.matches('section.tiles-section')) return;
    const grp = next.querySelector('figure.tile .ds')?.textContent; if (!grp || used.has(grp)) return;
    // the group's link lives under its LAST row; find it
    const link = [...document.querySelectorAll('section.tiles-section:not(.room-break)')]
      .filter(s => s.querySelector('figure.tile .ds')?.textContent === grp).map(s => s.querySelector('.see-link')).find(Boolean);
    if (!link) return;
    used.add(grp); link.classList.add('in-head'); head.appendChild(link);
  });
})();
